import format from 'date-fns/format';
import React from 'react';

import {
  Icon,
  Tag,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@eluve/components';
import { formatAppointmentTagLabel } from '@eluve/utils';

export type AppointmentTagData = {
  id: string;
  tag: string;
  isResolvable: boolean | null;
  isSystemTag: boolean | null;
  createdAt: string;
  updatedAt: string;
  resolvedAt: string | null;
  isSelfResolved: boolean | null;
};

type AppointmentTagProps = {
  onRemoveClick?: () => void;
  tag: AppointmentTagData;
};

export const AppointmentTag: React.FC<AppointmentTagProps> = ({
  onRemoveClick,
  tag,
}) => {
  const isResolvable = tag.isResolvable ?? false;
  const isSelfResolved = tag.isSelfResolved ?? false;
  const isSystemTag = tag.isSystemTag ?? false;

  let category;
  if (!tag.tag.includes('@') && tag.tag.includes('.')) {
    category = tag.tag.split('.')[0];
  }

  const tagElement = (
    <Tag
      color={isSystemTag ? 'orange' : 'teal'}
      className={tag.resolvedAt ? 'line-through hover:no-underline' : undefined}
      label={formatAppointmentTagLabel(tag.tag)}
      pill
      size="s"
    >
      {!isSystemTag && onRemoveClick && (
        <button
          onClick={onRemoveClick}
          className="-m-2 -mr-2.5 size-8 cursor-pointer rounded-full border-8 border-transparent bg-clip-padding p-px hover:bg-text-teal-subtle hover:text-bg-teal-subtle"
        >
          <Icon name="X" size="sm" />
        </button>
      )}
    </Tag>
  );

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div>{tagElement}</div>
      </TooltipTrigger>
      <TooltipContent>
        {category && (
          <p>
            <span className="opacity-60">Category: </span>
            {category}
          </p>
        )}
        <p>
          <span className="opacity-60">Created: </span>
          {format(new Date(tag.createdAt), 'MMM d, yyyy - h:mm a')}
        </p>
        {tag.updatedAt !== tag.createdAt && (
          <p>
            <span className="opacity-60">Updated: </span>
            {format(new Date(tag.updatedAt), 'MMM d, yyyy - h:mm a')}
          </p>
        )}
        {isResolvable && (
          <p>
            <span className="opacity-60">
              {isSelfResolved ? 'Self-resolved: ' : 'Resolved: '}
            </span>
            {tag.resolvedAt
              ? format(new Date(tag.resolvedAt), 'MMM d, yyyy - h:mm a')
              : '-'}
          </p>
        )}
      </TooltipContent>
    </Tooltip>
  );
};
